// 获取注册内容弹窗组件
export function getformerstudentsDialogData() {
    return [

        {
            key: "name",
            name: "姓名",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'


        }, {
            key: "sex",
            name: "性别",
            value: '男',
            type: 'radio',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "nation",
            name: "民族",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "political",
            name: "政治面貌",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "stuNum",
            name: "考生号",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'
        },
        {
            key: "phone",
            name: "联系电话",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        },
        {
            key: "contact",
            name: "紧急联系人电话",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "stuStatusNum",
            name: "中职学籍号",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'

        }, {
            key: "edSystem",
            name: "学制",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'
        }, {
            key: "school",
            name: "中职学校名称",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write',
            prompt: "(注:需填写学校全称)",

        }, {
            key: "profession",
            name: "中职专业名称",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write',
            prompt: "(注:需填写专业全称)",
        }, {
            key: "schoolAddress",
            name: "学校地址",
            value: '',
            type: 'input',
            isNull: false,
            writeOrRead: 'write'
        }, {
            key: "readyProfession",
            name: "报考专业",
            value: '',
            type: 'select',
            options: [{
                labe: '计算机科学与技术',
                value: '计算机科学与技术'
            },
                {
                    labe: '电子商务',
                    value: '电子商务'
                },
                {
                    labe: '财务管理',
                    value: '财务管理'
                },
            ],
            isNull: false,
            writeOrRead: 'write'

        }, {


            key: "diplomaFile",
            name: "中职毕业证原件上传",
            fileName: '',
            uploadTitle: "中职毕业证原件上传",
            type: 'uploadImg2',
            imgFlag: '',
            isNull: false,
            prompt: "",
            value: [
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "0"
                // },
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "1"
                // },
            ],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'write'

        },
        // {
        //     key: "stuStatusFile",
        //     name: "所在学校学籍表",
        //     fileList: [],
        //     fileName: '',
        //     uploadTitle: "所在学校学籍表",
        //     type: 'uploadImg',
        //     isNull: false,
        //     value: []

        // },
        // {
        //     key: "idCardFile",
        //     name: "身份证图片",
        //     idcardImgLIst: [{
        //         pathflag: 0,
        //         path: require("../../assets/img/sfzf.png"),
        //         info: "点击上传身份证人像面图片",
        //     },
        //     {
        //         pathflag: 0,
        //         path: require("../../assets/img/sfzz.png"),
        //         info: "点击上传身份证国徽面图片",
        //     },
        //     ],
        //     idCardflag: '0',
        //     uploadTitle: "身份证图片",
        //     type: 'idcardImg',
        //     isNull: false,
        //     // value: []
        // },
        {
            type: "radio2",
            name: "",
            isNull: true,
            zhinan: "非鼓励政策指南",
            writeOrRead: 'write'
        },
        {
            key: "withoutTestFile",
            name: "加分(免试)",
            fileName: '',
            uploadTitle: "加分(免试)",
            type: 'uploadImg3',
            isNull: false,
            // isTip: "指南",
            fujianload: '附件下载',
            url: "", // 附件url
            value: [],
            zhinan: "",
            fujianName: "",
            nameflag: true,
            writeOrRead: 'write'
        }, {
            key: "proveFile",
            name: "证明材料复印件",
            fileName: '',
            uploadTitle: "证明材料复印件",
            type: 'uploadImg3',
            isNull: false,
            // isTip: "指南",
            fujianload: '',
            url: "", // 附件url
            value: [],
            fujianName: "",
            nameflag: true,
            writeOrRead: 'write'

        },


    ]
}

//查看
export function showformerstudentsDialogData() {
    return [

        {
            key: "name",
            name: "姓名",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "sex",
            name: "性别",
            value: '男',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "nation",
            name: "民族",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "idCard",
            name: "身份证号",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "political",
            name: "政治面貌",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "stuNum",
            name: "考生号",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "phone",
            name: "联系电话",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        },
        {
            key: "contact",
            name: "紧急联系人电话",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "stuStatusNum",
            name: "中职学籍号",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "edSystem",
            name: "学制",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "school",
            name: "中职学校名称",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "profession",
            name: "中职专业名称",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "schoolAddress",
            name: "学校地址",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "readyProfession",
            name: "报考专业",
            value: '',
            type: 'text',
            isNull: true,
            writeOrRead: 'read'

        }, {
            key: "diplomaFile",
            name: "中职毕业证原件上传",
            fileName: '',
            uploadTitle: "中职毕业证原件上传",
            type: 'imgOrPdf',
            imgFlag: '',
            isNull: false,
            prompt: "",
            value: [
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "0"
                // },
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "1"
                // },
            ],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'read'


        },
        // {
        //     key: "stuStatusFile",
        //     name: "所在学校学籍表",
        //     value: [{
        //         path: ''
        //     }, {
        //         path: ''
        //     },],

        //     type: 'icons',
        //     isNull: true,

        // },
        // {
        //     key: "idCardFile",
        //     name: "身份证图片",
        //     value: [{
        //         path: ''
        //     },
        //     {
        //         path: ''
        //     },
        //     ],

        //     type: 'icons',
        //     isNull: true,

        // },
        {
            key: "withoutTestFile",
            name: "加分(免试)",
            fileName: '',
            uploadTitle: "加分(免试)",
            type: 'imgOrPdf',
            imgFlag: '',
            isNull: false,
            prompt: "",
            value: [
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "0"
                // },
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "1"
                // },
            ],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'read'
        },
        {
            key: "proveFile",
            name: "证明材料复印件",
            fileName: '',
            uploadTitle: "证明材料复印件",
            type: 'imgOrPdf',
            imgFlag: '',
            isNull: false,
            prompt: "",
            value: [
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "0"
                // },
                // {
                //     path: "",
                //     name: "1",
                //     imgFlag: "1"
                // },
            ],
            fujianload: '附件下载',
            url: "", // 附件url
            fujianName: "",
            writeOrRead: 'read'
        }
    ]
}
